

export const endpoints = {
  // authentication
  postUserAccountSignInApi: "auth/sign-in",
  postUserAccountSignUpApi: "auth/sign-up",
  postUserEmailVerification: "auth/initiate-reset",
  getVerifyToken:"auth/verify-reset",
  updateResetPassword:"auth/reset-password",

  //course
  getAllCourseApi: "course/",
  getSingleCourseApi: "course/single-course",
  postCourseApi: "course/add-course",
  updateCourseApi: "course/update-course",
  deleteCourseApi: "course/",

  //assessment
  getAllAssessmentApi: "assessment/all-assessments",
  postAssessmentApi: "assessment/create-assessment",
  updateAssessmentApi: "assessment/update-assessment",

  //question
  getAllQuestionsApi:"assessment/all-questions",
  postQuestionApi:"assessment/create-question",
  enrollForAssessmentApi: "assessment/enroll-for-assessment",
  nextQuestionApi: "assessment/next-question",
  assessmentResultApi: "assessment/user-assessment-result",
  submitAnswerApi: "assessment/submit-answer",
  getEnrolledAssessmentApi:"assessment/all-user-assessment-enrolled",

  userAssessmentResultApi: "assessments/user-assessments-result",
  getAllUserAssessment: "assessments/all-user-assessment-enrolled",

  // user
  getUsersApi: "user",
  getStudentsApi: "user/students",
  getFilterUsersApi: "user/filter",
  postUserApi: "auth/add-user",
  updateUserApi: "user/update-profile",

  // Class
  postLiveClassApi: "class/schedule-live-class",
  updateLiveClassApi: "class/update-live-class",
  getLiveClassApi:"class/all-live-class",

  // project
  getProjectFilterApi: "/project/filter",
  postCreateProjectApi: "project/create",
  putUpdateProjectApi: "project/update",
  deleteProjectApi: "project/delete",

  // board
  postCreateBoardApi: "task/board",
  getFilterBoardApi: "task/board/filter",
  deleteBoardApi: "task/board/delete",

  // task
  postCreateBoardTaskApi: "task/board/task",
  getBoardTaskApi: "task/board/task",
  putBoardTaskApi: "task/board/task",
  getFilterBoardTaskApi: "task/board/task/filter",
  deleteBoardTaskApi: "task/board/task/delete",

  // team
  postGenerateInviteApi: "team/invitation/generate-invite",
  postAcceptInviteApi: "team/invitation/accept-invite",
  postAddMemberToEntity: "team/member/add-to-entity",
  getFilterMembersApi: "team/member/filter",
  getFilterTeamApi: "team/filter",
  postTeamApi: "team",

  // workspace
  getWorkSpaceKpi: "workspace/workspace/kpi",

  // chat
  postAddChatApi: "chat/add-chat",
  getFilterChatsApi: "chat/filter-chats",
  postSendMessageApi: "chat/send-message",
  getFilterMessagesApi: "chat/filter-messages",
  deleteMessageApi: "chat/delete-message",

  // leave
  getLeaveFilterApi: "/leave/filter",
  postAddLeaveApi: "leave/add",
  putUpdateLeaveApi: "leave/update",
  deleteLeaveApi: "leave/delete",

  // department
  getDepartmentFilterApi: "department/filter",
  postAddDepartmentApi: "department/add",
  putUpdateDepartmentApi: "department/update",
  deleteDepartmentApi: "department/delete",
};
